import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

Injectable();
 
export const ErrorInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next): Observable<HttpEvent<any>> => {
  const snackBar = inject(MatSnackBar);
  const translate = inject(TranslateService);
  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      switch (err.status) {
        case 400:
          translate.get(err.error?.message).subscribe((translation: string) => {
            snackBar.open(translation, 'Close', {
              duration: 10000,
              panelClass: ['snackbar'],
              verticalPosition: 'bottom',
              horizontalPosition: 'center',
            });
          });
          break;
        case 422:
          translate.get(err.error?.message).subscribe((translation: string) => {
            snackBar.open(translation, 'Close', {
              duration: 10000,
              panelClass: ['snackbar'],
              verticalPosition: 'bottom',
              horizontalPosition: 'center',
            });
          });
          break;
        case 403: // Show message
          break;
        case 409: // Show message
          break;
        case 429:
          break;
        case 500:
          translate
            .get('Something went wrong.. Our team is working on fixing the problem')
            .subscribe((translation: string) => {
              snackBar.open(translation, 'Close', {
                duration: 10000,
                panelClass: ['snackbar'],
                verticalPosition: 'bottom',
                horizontalPosition: 'center',
              });
            });
          break;
        case 503:
          break;
      }

      // Re-throw the error to propagate it further
      return throwError(() => err);
    })
  );
};
